export class MoleculePanelOverviewHeaderMultiRestoreWebhostingActionComponent {
    public templateUrl = require('./multi-restore-webhosting-webspace-action.html?external');
}
